import wechatIcon from '@/assets/images/social_icons/32/weixin.png';
import weiboIcon from '@/assets/images/social_icons/32/weibo.png';
import qzoneIcon from '@/assets/images/social_icons/32/qzone.png';
import doubanIcon from '@/assets/images/social_icons/32/douban.png';
import facebookIcon from '@/assets/images/social_icons/32/facebook.png';
import twitterIcon from '@/assets/images/social_icons/32/twitter.png';
import googlePlusIcon from '@/assets/images/social_icons/32/google_plus.png';
import { setQrCodeModalData } from '@/actions/GlobalAction';
import i18n from 'react-intl-universal';
import classNames from 'classnames';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import styles from './ShareMenu.scss';

import { MenuItem, SubMenu } from '../../../components/Menu';
import shareToSNS from '../../../utils/share';

@connect(
  state => ({
  }),
  dispatch => ({
    setQrCodeModalData: (show, data) => dispatch(setQrCodeModalData(show, data)),
  }),
)
class ShareMenu extends Component {
  static defaultProps = {
    direction: 'left',
  };

  state = {
    sns: [
      {
        action: 'wechat',
        text: i18n.get('share.to-wechat'),
        icon: wechatIcon,
      },
      {
        action: 'weibo',
        text: i18n.get('share.to-weibo'),
        icon: weiboIcon,
      },
      {
        action: 'qzone',
        text: i18n.get('share.to-qzone'),
        icon: qzoneIcon,
      },
      {
        action: 'douban',
        text: i18n.get('share.to-douban'),
        icon: doubanIcon,
      },
      {
        action: 'facebook',
        text: i18n.get('share.to-facebook'),
        icon: facebookIcon,
      },
      {
        action: 'twitter',
        text: i18n.get('share.to-twitter'),
        icon: twitterIcon,
      },
      {
        action: 'google_plus',
        text: i18n.get('share.to-googleplus'),
        icon: googlePlusIcon,
      },
    ],
  };

  onClick = (e, action) => {
    const { shareData } = this.props;
    if (action.index === 'wechat') {
      this.props.setQrCodeModalData(true, { link: shareData.link });
      return;
    }
    shareToSNS(action.index, shareData.link, shareData.title, shareData.text);
  };

  /* 支持过滤某些分享项
   * @filterItems 需要过滤掉的分享项
   */
  getSubMenuItems = (filterItems = [], renderText = false) => {
    const { sns } = this.state;
    return sns.filter(v => filterItems.indexOf(v.action) < 0).map((v, index) => {
      return (
        <MenuItem key={index} index={v.action} className={styles['shareitem']}>
          <img src={v.icon} alt=""/>
          { v.text }
        </MenuItem>
      );
    });
  };

  render() {
    const {
      text,
      index,
      className,
      iconName,
      direction,
      filterItems,
      renderText,
    } = this.props;
    return (
      <SubMenu
        text={text}
        iconName={iconName && 'share'}
        index={index}
        onClick={this.onClick}
        direction={direction}
        className={classNames(styles['sharemenu'], className)}
      >
        { this.getSubMenuItems(filterItems, renderText) }
      </SubMenu>
    );
  }
}

export default ShareMenu;



// WEBPACK FOOTER //
// ./src/components/Menu/ShareMenu/ShareMenu.js